import React, { useEffect } from 'react'
import { TextStyle } from 'react-native'
import { Header, color } from '@trivie/ui-mobile'
import { setPageTitle } from '@trivie/core'
import { SettingsList } from '../../profile'

export const SettingsScreen = () => {
  useEffect(() => {
    setPageTitle(`Settings - ${process.env.REACT_APP_SITE_TITLE}`)
  }, [])

  return (
    <div style={CONTAINER}>
      <div style={HEADER_STICKY_CONTAINER}>
        <div style={HEADER_FLEX_CONTAINER}>
          <Header titleStyle={HEADER_TITLE} headerTx="Settings.header" />
        </div>
      </div>
      <SettingsList />
    </div>
  )
}

/**
 * Styling
 */
const CONTAINER: React.CSSProperties = {
  backgroundColor: color.white,
}
const HEADER_TITLE: TextStyle = { fontSize: 24, color: color.black }
const HEADER_STICKY_CONTAINER: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 99,
  backgroundColor: 'white',
}
const HEADER_FLEX_CONTAINER: React.CSSProperties = {
  display: 'flex',
  maxWidth: '1440px',
  justifyContent: 'space-between',
}
